import React, { useEffect, useState } from "react";
import "./Centralization.css";
import SB from "../../assets/Smart-Building.png";
import SC from "../../assets/Smart-City.png";
import SF from "../../assets/Smart-Factory.png";
import { useTranslation } from "react-i18next";

function Centralization() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.screen.width <= 932);

  useEffect(() => {
    // Detect the window size for mobile responsiveness
    const handleResize = () => {
      setIsMobile(window.screen.width <= 932); // Update based on screen size
    };
  
    handleResize(); // Call on component mount
    window.addEventListener("resize", handleResize);
    
    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Create an IntersectionObserver to trigger the animation when in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible"); // Add class when in view
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is in the viewport
      }
    );

    // Select all elements with the 'card-centraliz-content' class
    const elements = document.querySelectorAll(".card-centraliz-content");
    elements.forEach((element) => {
      observer.observe(element); // Observe each element
    });

    return () => {
      observer.disconnect(); // Clean up observer
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible"); // Add class when in view
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is in the viewport
      }
    );
  
    // Select all elements with the 'mobile-card-centraliz-content' class
    const elements = document.querySelectorAll(".mobile-card-centraliz-content");
    elements.forEach((element) => {
      observer.observe(element); // Observe each element
    });
  
    return () => {
      observer.disconnect(); // Clean up observer
    };
  }, []);
  

  return (
    <div id="centralized-content" className="centraliz-content">
      <div className="header-centraliz">
        <div className="text-header-centraliz">Centralized Platform</div>
        <div className="sub-header-centraliz">{t("main_head_centralized")}</div>
      </div>

      {!isMobile && (
        <div className="bg-centraliz">
          <div>
            <div className="esg-image-header">Centralized Platform</div>
            <div className="esg-image-sub">
              <li>{t("main_sub_centralized_1")}</li>
              <li>{t("main_sub_centralized_2")}</li>
              <li>{t("main_sub_centralized_3")}</li>
              <li>{t("main_sub_centralized_4")}</li>
              <li>{t("main_sub_centralized_5")}</li>
              <li>{t("main_sub_centralized_6")}</li>
              <li>{t("main_sub_centralized_7")}</li>
              <li>{t("main_sub_centralized_8")}</li>
            </div>
          </div>

          <div className="card-centraliz-content">
            <div className="card-image-centraliz-content">
              <div className="smart-city-centraliz">
                <img src={SC} alt="Smart City" />
                <div className="smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart City</div>
                  <div className="sub-card-cent">{t("main_smart_city")}</div>
                </div>
              </div>
              <div className="smart-city-centraliz">
                <img src={SB} alt="Smart Building" />
                <div className="smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart Building</div>
                  <div className="sub-card-cent">{t("main_smart_building")}</div>
                </div>
              </div>
              <div className="smart-city-centraliz">
                <img src={SF} alt="Smart Factory" />
                <div className="smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart Factory</div>
                  <div className="sub-card-cent">{t("main_smart_factory")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile && (
        <div>
          <div className="bg-centraliz">
            <div>
              <div className="esg-image-header">Centralized Platform</div>
              <div className="esg-image-sub">
                <li>{t("main_sub_centralized_1")}</li>
                <li>{t("main_sub_centralized_2")}</li>
                <li>{t("main_sub_centralized_3")}</li>
                <li>{t("main_sub_centralized_4")}</li>
                <li>{t("main_sub_centralized_5")}</li>
                <li>{t("main_sub_centralized_6")}</li>
                <li>{t("main_sub_centralized_7")}</li>
                <li>{t("main_sub_centralized_8")}</li>
              </div>
            </div>
          </div>

          <div className="mobile-card-centraliz-content">
            <div className="mobile-card-image-centraliz-content">
              <div className="mobile-smart-city-centraliz">
                <img src={SC} alt="Smart City" />
                <div className="mobile-smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart City</div>
                  <div className="mobile-sub-card-cent">{t("main_smart_city")}</div>
                </div>
              </div>
              <div className="mobile-smart-city-centraliz">
                <img src={SB} alt="Smart Building" />
                <div   className="mobile-smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart Building</div>
                  <div className="mobile-sub-card-cent">{t("main_smart_building")}</div>
                </div>
              </div>
              <div className="mobile-smart-city-centraliz">
                <img src={SF} alt="Smart Factory" />
                <div className="mobile-smart-city-text">
                  <div style={{ fontSize: "24px" }}>Smart Factory</div>
                  <div className="mobile-sub-card-cent">{t("main_smart_factory")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Centralization;
